/** PostMessage type sent by mfa-callback.html on successful setup */
export const MFA_COMPLETE_MESSAGE_TYPE = 'mfa-setup-complete';

/** Interval (ms) for polling whether the popup window has been closed */
export const POPUP_POLL_INTERVAL_MS = 500;

/** Default popup dimensions for MFA setup pages */
const MFA_POPUP_WIDTH = 520;
const MFA_POPUP_HEIGHT = 700;

interface PopupConfig {
  url: string;
  name: string;
  width: number;
  height: number;
}

/**
 * Open a centered popup window with the given configuration.
 * Returns the Window reference, or null if blocked by a popup blocker.
 */
export function openCenteredPopup(config: PopupConfig): Window | null {
  const { url, name, width, height } = config;
  const left = Math.round(window.screenX + (window.outerWidth - width) / 2);
  const top = Math.round(window.screenY + (window.outerHeight - height) / 2);

  const features = [
    `width=${width}`,
    `height=${height}`,
    `left=${left}`,
    `top=${top}`,
    'menubar=no',
    'toolbar=no',
    'location=yes',
    'status=no',
    'scrollbars=yes',
    'resizable=yes',
  ].join(',');

  return window.open(url, name, features);
}

/**
 * Open a popup window sized for MFA setup.
 * Returns the Window reference, or null if blocked.
 */
export function openMfaPopup(url: string): Window | null {
  return openCenteredPopup({
    url,
    name: 'vertex-mfa-setup',
    width: MFA_POPUP_WIDTH,
    height: MFA_POPUP_HEIGHT,
  });
}
